'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gtm;

var _gtm = require('../actions/gtm');

function gtm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _gtm.SET_GTM_DATA_LAYER:
      return { dataLayer: action.dataLayer };
    case _gtm.CLEAR_GTM_DATA_LAYER:
      return { dataLayer: [] };
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/gtm.js
// module id = 2348
// module chunks = 0